import * as React from "react"
import {ThemeProvider} from "styled-components"

import {NotificationsProvider} from "../../contexts/notifications.js"
import {FetcherProvider} from "../../contexts/fetcher.js"
import {IntlProvider} from "../../services/intl.js"

import View from "../../components/view.js"

import Arrivals from "../arrivals/index.js"

import theme from "./theme.js"
import GlobalStyles from "./global-styles.js"

import "react-datepicker/dist/react-datepicker.css"
import "@reach/listbox/styles.css"
import "../../components/listbox.css"
import "@reach/tooltip/styles.css"
import "../../components/tooltip.css"
import "@reach/dialog/styles.css"
import "../../components/dialog.css"
import "@reach/menu-button/styles.css"
import "../../components/menu-button.css"

const App = () => {
  const [locale, setLocale] = React.useState()

  React.useEffect(() => {
    const lang = document.location?.search
      .split("&")
      .find(str => str.includes("lang"))
      .split("=")[1]
      .substr(0, 2)
      .toLowerCase()
    switch (lang) {
      case "en":
        import(`../../locales/en.js`).then(({locale, messages}) =>
          setLocale({locale, messages})
        )
        break
      case "fr":
        import(`../../locales/fr.js`).then(({locale, messages}) =>
          setLocale({locale, messages})
        )
        break
      case "de":
        import(`../../locales/de.js`).then(({locale, messages}) =>
          setLocale({locale, messages})
        )
        break
      case "es":
        import(`../../locales/es.js`).then(({locale, messages}) =>
          setLocale({locale, messages})
        )
        break
      case "it":
        import(`../../locales/it.js`).then(({locale, messages}) =>
          setLocale({locale, messages})
        )
        break
    }
  }, [])

  if (!locale) return null

  return (
    <NotificationsProvider>
      <FetcherProvider>
        <IntlProvider locale={locale.locale} messages={locale.messages}>
          <GlobalStyles />
          <ThemeProvider theme={theme}>
            <View id="react-cico-app">
              <Arrivals />
            </View>
          </ThemeProvider>
        </IntlProvider>
      </FetcherProvider>
    </NotificationsProvider>
  )
}

const goTo = href => {
  window.parent.postMessage({goTo: href}, "*")
  return false
}
const copy = str => window.parent.postMessage({copy: str}, "*")

window.copy = copy
window.goTo = goTo

export default App
